// extracted by mini-css-extract-plugin
export default {"genericCard":"Ps-z","inline":"Qs-z","mastercard":"Rs-z","discover":"Ss-z","visa":"Ts-z","amex":"Us-z","active":"Vs-z"};